// Lógica pura de la pestaña "Licencias y correos": qué hay que mandar al
// servidor al guardar una fila y cuándo la fila tiene cambios sin guardar.

const limpio = (v) => (v ?? '').trim();

export const filaDeServidor = (f) => ({
  email: f.email ?? '',
  numero: f.numero_licencia ?? '',
  fecha: f.fecha_expiracion ?? '',
});

export const hayCambios = (original, borrador) =>
  limpio(original.email) !== limpio(borrador.email)
  || limpio(original.numero) !== limpio(borrador.numero)
  || limpio(original.fecha) !== limpio(borrador.fecha);

// Devuelve { error } o las acciones: `email` (undefined = sin cambio, null =
// borrar) y `licencia` ('guardar' | 'borrar' | null). Nº y fecha van juntos:
// o los dos, o ninguno (ninguno borra la licencia que hubiera).
export const accionesDeFila = (original, borrador) => {
  const numero = limpio(borrador.numero);
  const fecha = limpio(borrador.fecha);
  if (Boolean(numero) !== Boolean(fecha)) {
    return { error: 'Rellena el número de licencia y la fecha de caducidad, o deja los dos vacíos.' };
  }

  const acciones = { email: undefined, licencia: null };
  if (limpio(original.email) !== limpio(borrador.email)) acciones.email = limpio(borrador.email) || null;

  const habiaLicencia = Boolean(limpio(original.numero));
  if (numero && (numero !== limpio(original.numero) || fecha !== limpio(original.fecha))) acciones.licencia = 'guardar';
  if (!numero && habiaLicencia) acciones.licencia = 'borrar';
  return acciones;
};

export const resumenFaltas = (filas) => ({
  sinCorreo: filas.filter((f) => !limpio(f.email)).length,
  sinLicencia: filas.filter((f) => !limpio(f.numero_licencia)).length,
});
